import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets scroll to the top of the page on every route (pathname) change so a new page
// never opens mid-scroll. Query-string-only changes (e.g. ?q= search) are left alone.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    const toTop = () => { window.scrollTo(0, 0); const m = document.querySelector("main"); if (m) m.scrollTop = 0; };
    toTop();
    // Safety net: re-assert top on the next frame to defeat child mount effects that scroll.
    const raf = requestAnimationFrame(toTop);
    return () => cancelAnimationFrame(raf);
  }, [pathname]);
  return null;
}
